/* global axios */
// v109 (WhatsApp Call — Fases 3/4): client da API do menu WhatsApp Call.
const base = accountId => `/api/v1/accounts/${accountId}/whatsapp_calls`;

export default {
  lista(accountId, params = {}) {
    return axios.get(base(accountId), { params });
  },
  resumo(accountId, params = {}) {
    return axios.get(`${base(accountId)}/resumo`, { params });
  },
  config(accountId) {
    return axios.get(`${base(accountId)}/config`);
  },
  setChaveGeral(accountId, ativo) {
    return axios.post(`${base(accountId)}/config`, { ativo });
  },
  setUsuario(accountId, userId, ativo) {
    return axios.post(`${base(accountId)}/config_usuario`, {
      user_id: userId,
      ativo,
    });
  },
  // Fase 2c (voz WebRTC): atender manda o SDP answer do navegador.
  atender(accountId, callId, sdp) {
    return axios.post(`${base(accountId)}/${callId}/atender`, { sdp });
  },
  recusar(accountId, callId) {
    return axios.post(`${base(accountId)}/${callId}/recusar`);
  },
  // OUTBOUND: origina ligação pro cliente com o SDP offer do navegador.
  originar(accountId, { inboxId, to, sdp }) {
    return axios.post(`${base(accountId)}/originar`, {
      inbox_id: inboxId,
      to,
      sdp,
    });
  },
  encerrar(accountId, callId) {
    return axios.post(`${base(accountId)}/${callId}/encerrar`);
  },
};
